import {
  DroppableContainer,
  KeyboardCode,
  KeyboardCoordinateGetter,
  closestCorners,
  getFirstCollision,
} from '@dnd-kit/core';

const directions: string[] = [
  KeyboardCode.Down,
  KeyboardCode.Right,
  KeyboardCode.Up,
  KeyboardCode.Left,
];

// Modified from https://github.com/clauderic/dnd-kit/blob/master/packages/sortable/src/sensors/keyboard/sortableKeyboardCoordinates.ts
// This function uses the rects around the parent element, rather than the actual element that triggers a drag.
// The parent element is the whole tab, but you can trigger the drag only from the text on the tab.
// This function moves the tab the correct amount left or right and takes into consideration the margin between tabs.
export const explorerTabsDndKeyboardCoordinateGetter: KeyboardCoordinateGetter =
  (event, { currentCoordinates, context: { active, droppableContainers } }) => {
    const droppableContainersWithUpdatedRects = droppableContainers
      .getEnabled()
      .map((droppableContainer) => ({
        ...droppableContainer,
        rect: {
          current:
            droppableContainer?.node.current?.parentElement?.getBoundingClientRect() ??
            null,
        },
      }));
    const collisionRect = droppableContainersWithUpdatedRects.find(
      (container) => container.id === active?.id,
    )?.rect.current;

    if (directions.includes(event.code)) {
      event.preventDefault();

      if (!active || !collisionRect) {
        return;
      }

      const filteredContainers: DroppableContainer[] = [];

      droppableContainersWithUpdatedRects.forEach((entry) => {
        if (!entry || entry?.disabled) {
          return;
        }

        const rect = entry?.rect.current;

        if (!rect) {
          return;
        }

        switch (event.code) {
          case KeyboardCode.Left:
            if (collisionRect.left > rect.left) {
              filteredContainers.push(entry);
            }
            break;
          case KeyboardCode.Right:
            if (collisionRect.left < rect.left) {
              filteredContainers.push(entry);
            }
            break;
          default:
            break;
        }
      });

      const collisions = closestCorners({
        active,
        collisionRect,
        droppableContainers: filteredContainers,
        pointerCoordinates: null,
      });
      const closestId = getFirstCollision(collisions, 'id');
      const closestContainer = droppableContainersWithUpdatedRects.find(
        ({ id }) => id === closestId,
      );

      if (!closestContainer?.rect.current) return undefined;
      // move this tab to the spot where the next tab is
      return {
        ...currentCoordinates,
        x: closestContainer.rect.current.left + 13, // 13 is the padding to the left (12) + 1 px for border
      };
    }

    return undefined;
  };
